export const NORTH = 0;
export const EAST = 1;
export const SOUTH = 2;
export const STORAGE_KEY = "lp_route";
//there were no left turns.